export const createDeleteWebhookForm = id => `marketplaceWebhookForm${id}`;
